import { render, staticRenderFns } from "./repairDetails.vue?vue&type=template&id=60d34f74&scoped=true&"
import script from "./repairDetails.vue?vue&type=script&lang=js&"
export * from "./repairDetails.vue?vue&type=script&lang=js&"
import style0 from "./repairDetails.vue?vue&type=style&index=0&id=60d34f74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d34f74",
  null
  
)

export default component.exports